import {
  normalizePhoneCanonical,
  phonesMatch,
} from './whatsappPhone';

export type ClientPhoneIdentity = {
  id?: string;
  phone?: string | null;
};

/**
 * Téléphone à persister : canonique E.164 sans + (ex. 2376…).
 * Retourne null si vide / non normalisable.
 */
export function resolvePersistableClientPhone(
  phone: string | undefined | null
): string | null {
  if (phone === undefined || phone === null) return null;
  const trimmed = String(phone).trim();
  if (!trimmed) return null;
  return (
    normalizePhoneCanonical(trimmed) ||
    trimmed.replace(/\D/g, '') ||
    null
  );
}

/** Client existant dont le téléphone matche (hors `excludeId`). */
export function findDuplicateClientByPhone<T extends ClientPhoneIdentity>(
  clients: T[],
  phone: string | undefined | null,
  excludeId?: string
): T | undefined {
  const candidate = resolvePersistableClientPhone(phone);
  if (!candidate) return undefined;
  return clients.find((c) => {
    if (excludeId && c.id && c.id === excludeId) return false;
    return phonesMatch(c.phone, candidate);
  });
}
